import axios from "axios";
import { error } from "jquery";

const getToken = () => {
  const token = localStorage.getItem('AccessTokenTAC');
  if (token !== "" && token !== null && token !== undefined) {
    return { 'Authorization': `Bearer ${token}` };
  }
  return {};
}

// Common method for GET requests
const GET = async (url) => {
  const headers = getToken();
  return await axios.get(url, { headers }).catch((error) => {
    throw error;
  });
};

// Common method for POST requests
const POST = async (url, data = {}) => {
  const headers = getToken();
  return await axios.post(url, data, { headers }).catch((error) => {
    throw error;
  });
};

// Common method for PUT requests
const PUT = async (url, data = {}) => {
  const headers = getToken();
  return await axios.put(url, data, { headers }).catch((error) => {
    throw error;
  });
};

// Common method for DELETE requests
const DELETE = async (url, data = {}) => {
  const headers = getToken();
  return await axios({
    method: 'delete',
    url: url,
    headers: headers,
    data: data // Payload should be in the `data` field
  }).catch((error) => {
    throw error;
  });
};

const logoutRedirect = async (url) => {

  const headers = getToken();
  return await axios.get(url, { headers }).catch((error) => {
    throw error;
  });
}



export default { GET, POST, PUT, DELETE, getToken, logoutRedirect };
